export default "__VITE_ASSET__Bfc740e8__"